/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type UserAvatar_user$ref: FragmentReference;
declare export opaque type UserAvatar_user$fragmentType: UserAvatar_user$ref;
export type UserAvatar_user = {|
  +id: string,
  +avatar: ?string,
  +firstName: string,
  +$refType: UserAvatar_user$ref,
|};
export type UserAvatar_user$data = UserAvatar_user;
export type UserAvatar_user$key = {
  +$data?: UserAvatar_user$data,
  +$fragmentRefs: UserAvatar_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "UserAvatar_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "avatar",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstName",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4f7c52cfabaffcd8e6256f7a6fcec447';
module.exports = node;
